import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, useMediaQuery } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& svg': {
      fill: '#666',
    },
  },
  headline: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.5rem 0',
    [theme.breakpoints.up('md')]: {
      marginBottom: '1rem',
      padding: 0,
    },
  },
}));

export const FooterAccordion = ({ title, children, staticUp }) => {
  const [expanded, setExpanded] = useState(false);
  const matches = useMediaQuery((theme) => theme.breakpoints.up(staticUp));
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography
        variant="h3"
        className={classes.headline}
        onClick={() => !matches && setExpanded((expanded) => !expanded)}
      >
        {title}
        {matches ? null : expanded ? <ExpandLess /> : <ExpandMore />}
      </Typography>
      <Collapse in={expanded || matches}>{children}</Collapse>
    </div>
  );
};

FooterAccordion.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  staticUp: PropTypes.string,
};

export default FooterAccordion;
